/**
 * La memoria dei dati della dashboard, messa a disposizione dei widget.
 * Il componente che la crea e' DatiDashboard.tsx; i widget la leggono con
 * useFonte (src/hooks/useFonte.ts). Sta in un file a parte perche' un file di
 * componenti React deve esportare solo componenti.
 */

import { createContext } from 'react';
import type { CacheFonti } from '../../lib/dashboard/cacheFonti';
import type { DatiFonti } from '../../lib/dashboard/fonti';

export interface ValoreDatiDashboard {
  cache: CacheFonti<DatiFonti>;
  /** La data di oggi in Italia; cambia a mezzanotte anche a pagina aperta. */
  oggi: string;
}

export const ContestoDati = createContext<ValoreDatiDashboard | null>(null);
